import { StyleSheet } from 'react-native';
import Theme from 'Theme';

export const defaultStyles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingBottom: 10
    },
    platformContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignSelf: 'stretch',
        paddingHorizontal: 23,
        paddingVertical: 10
    },
    recPlatform: {
        marginLeft: 12,
        fontSize: 20,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor
    }
});

export const landscapeStyles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    platformContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignSelf: 'stretch',
        paddingTop: 5,
        paddingBottom: 10
    },
    recPlatform: {
        marginLeft: 12,
        fontSize: 20,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor
    }
});
